import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashRegisterXReport } from "../../../types/cash/report";

interface CashReportState {

  report: CashRegisterXReport | null;

  loading: boolean;

}

const initialState: CashReportState = {

  report: null,
  loading: false

};

const cashReportSlice = createSlice({

  name: "cashReport",

  initialState,

  reducers: {

    /**
     * 📊 Set reporte
     */
    setReport(state, action: PayloadAction<CashRegisterXReport>) {
      state.report = action.payload;
    },

    /**
     * ⏳ Loading
     */
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    /**
     * 🧹 Clear
     */
    clearReport(state) {
      state.report = null;
    }

  }

});

export const {
  setReport,
  setLoading,
  clearReport
} = cashReportSlice.actions;

export default cashReportSlice.reducer;